export const icon_edit = (<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.54951 4.37796L6.59605 1.91675L0 9.79263L0.246121 12.5L2.95346 12.2538L9.54951 4.37796Z" fill="currentColor" />
  <path d="M7.23584 1.12919L10.1893 3.63963L10.9277 2.75359C11.1738 2.40902 11.1246 1.91678 10.8292 1.67066L9.05714 0.193929C8.71257 -0.101416 8.26955 -0.0521918 7.9742 0.292378L7.23584 1.12919Z" fill="currentColor" />
</svg>
)